import React from 'react';
import { useFormik } from 'formik';
import { postDataToTheServer } from '../../../../helpers/api';
import AppURL from '../../../../constants/AppURL';
import { ToastSuccess, ToastWarning } from '../../../../constants/Toast';
import Container from '../../../../constants/Container';
import SecHeading from '../../../../constants/SecHeading';
import { Grid } from '@mui/material';
import InputTextBox from '../../../../constants/InputTextBox';
import { handleChangePhone, handleNepaliInputChange, handleSelectBox } from '../../../../helpers/handleChange';
import { EndBaseLine } from '../../../../constants/AppSpace';
import { Button } from '../../../../constants/Button';
import SelectInputBox from '../../../../constants/SelectInputBox';
import { YesNoOptions } from '../../../../constants/Options';
import NepaliInputBox from '../../../../constants/NepaliInputBox';

interface ItemSuppilerFormViewProps {
    handleFormSuccess: () => void;
}
const ItemSuppilerCreateView: React.FC<ItemSuppilerFormViewProps> = ({ handleFormSuccess }) => {
    const initialValues = {
        supp_name: "",
        supp_name_nep: "",
        sup_phone: "",
        sup_email: "",
        sup_address: "",
        sup_address_nep: "",
        per_name: "",
        per_name_nep: "",
        per_phone: "",
        per_email: "",
        remarks: "",
    };
    const { values, errors, touched, setFieldValue, isSubmitting, handleBlur, handleChange, handleSubmit } = useFormik({
        initialValues,
        // validationSchema: toleValidationSchema,
        enableReinitialize: true,
        onSubmit: async (values, action) => {
            const formData = new FormData();
            Object.keys(values).forEach((key) => {
                const value = (values as Record<string, any>)[key];
                if (value !== undefined && value !== null && value !== "") {
                    formData.append(key, value);
                }
            });
            try {
                await postDataToTheServer(AppURL.InventoryURL + 'inventory/product/item/suppiler/create/list/view/', formData).then((res) => {
                    if (res?.status === 201) {
                        handleFormSuccess();
                        action.resetForm();
                        ToastSuccess({ message: res?.message });
                    } else if (res?.status === 400) {
                        ToastWarning({ message: res?.message });
                    }
                    else {
                        ToastWarning({ message: "Some Issue" });
                    }
                });
            } catch (error) {
                console.log(error);
            }
        },
    });
    return (
        <Container padding={true}>
            <form onSubmit={handleSubmit}>
                <SecHeading type='add' label='Suppiler Add' />
                <Grid container columnSpacing={3} rowSpacing={0.8}>
                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='text'
                            name='supp_name'
                            label='Suppiler Name'
                            handleChange={handleChange}
                            value={values.supp_name}
                            error={errors.supp_name}
                            handleBlur={handleBlur}
                            touched={touched.supp_name}
                            required={true}
                            placeholder='Enter Suppiler Name'
                        />
                    </Grid>
                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <NepaliInputBox
                            label='Suppiler Name(Nepali)'
                            name='supp_name_nep'
                            value={values.supp_name_nep}
                            handleChange={(e) => handleNepaliInputChange(e, { setFieldValue, name: 'supp_name_nep' })}
                            required={true}
                            handleBlur={handleBlur}
                            error={errors.supp_name_nep}
                            placeholder='Enter Suppiler Name(Nepali)'
                            touched={touched.supp_name_nep}
                        />
                    </Grid>

                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='text'
                            name='sup_phone'
                            label='Suppiler Phone No.'
                            handleChange={(e) => handleChangePhone(e, { setFieldValue, name: 'sup_phone' })}
                            value={values.sup_phone}
                            error={errors.sup_phone}
                            handleBlur={handleBlur}
                            touched={touched.sup_phone}
                            required={false}
                            placeholder='Enter Phone No.'
                        />
                    </Grid>
                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='email'
                            name='sup_email'
                            label='Suppiler E-mail'
                            handleChange={handleChange}
                            value={values.sup_email}
                            error={errors.sup_email}
                            handleBlur={handleBlur}
                            touched={touched.sup_email}
                            required={false}
                            placeholder='Enter Suppiler Email'
                        />
                    </Grid>

                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='text'
                            name='sup_address'
                            label='Suppiler Address'
                            handleChange={handleChange}
                            value={values.sup_address}
                            error={errors.sup_address}
                            handleBlur={handleBlur}
                            touched={touched.sup_address}
                            required={true}
                            placeholder='Enter Suppiler Address'
                        />
                    </Grid>
                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <NepaliInputBox
                            label='Suppiler Address(Nepali)'
                            name='sup_address_nep'
                            value={values.sup_address_nep}
                            handleChange={(e) => handleNepaliInputChange(e, { setFieldValue, name: 'sup_address_nep' })}
                            required={true}
                            handleBlur={handleBlur}
                            error={errors.sup_address_nep}
                            placeholder='Enter Suppiler addres(Nepali)'
                            touched={touched.sup_address_nep}
                        />
                    </Grid>
                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='text'
                            name='per_name'
                            label='Contact Person Name'
                            handleChange={handleChange}
                            value={values.per_name}
                            error={errors.per_name}
                            handleBlur={handleBlur}
                            touched={touched.per_name}
                            required={true}
                            placeholder='Enter Contact Person Name'
                        />
                    </Grid>
                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <NepaliInputBox
                            label='Contact Person Name(Nepali)'
                            name='per_name_nep'
                            value={values.per_name_nep}
                            handleChange={(e) => handleNepaliInputChange(e, { setFieldValue, name: 'per_name_nep' })}
                            required={true}
                            handleBlur={handleBlur}
                            error={errors.per_name_nep}
                            placeholder='Enter Contact Person Name(Nepali)'
                            touched={touched.per_name_nep}
                        />
                    </Grid>
                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='text'
                            name='per_phone'
                            label='Contact Person Phone No.'
                            handleChange={(e) => handleChangePhone(e, { setFieldValue, name: 'per_phone' })}
                            value={values.per_phone}
                            error={errors.per_phone}
                            handleBlur={handleBlur}
                            touched={touched.sup_phone}
                            required={false}
                            placeholder='Enter Contact Phone No.'
                        />
                    </Grid>
                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='email'
                            name='per_email'
                            label='Contact Person E-mail'
                            handleChange={handleChange}
                            value={values.per_email}
                            error={errors.per_email}
                            handleBlur={handleBlur}
                            touched={touched.per_email}
                            required={false}
                            placeholder='Enter Contact Person Email'
                        />
                    </Grid>
                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='text'
                            name='remarks'
                            label='Remarks'
                            handleChange={handleChange}
                            value={values.remarks}
                            error={errors.remarks}
                            handleBlur={handleBlur}
                            touched={touched.remarks}
                            required={false}
                            placeholder='Enter Remarks'
                        />
                    </Grid>

                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <EndBaseLine top={18}>
                            <Button btn_type='save' type='submit' el='button' />
                        </EndBaseLine>
                    </Grid>
                </Grid>
            </form>

        </Container>
    )
}

export default ItemSuppilerCreateView